import { Dialog } from "@mui/material";
import { memo } from "react";
import * as css from "./merchant-customizable-modal.module.css";

export const MerchantCustomizableModal = memo(
  function MerchantCustomizableModal({
    open,
    onClose,
    children,
    fullscreen,
    backdropColor,
    ariaLabel,
  }: {
    open: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    fullscreen: boolean;
    backdropColor?: string;
    ariaLabel?: string;
  }) {
    const stopPropagation = (e: React.MouseEvent) => {
      e.stopPropagation();
    };

    return (
      <>
        <style>{`.MuiBackdrop-root{background-color: ${backdropColor};}`}</style>
        <Dialog
          aria-label={ariaLabel}
          className={`${css.modalWrapper} ${fullscreen ? css.fullscreen : ""}`}
          fullScreen={fullscreen}
          onClose={(_, reason) => {
            if (reason !== "backdropClick") {
              onClose();
            }
          }}
          open={open}
        >
          <div onClick={stopPropagation}>{children}</div>
        </Dialog>
      </>
    );
  },
);
